<template>
    <label class="flex flex-col">
        <span class="mb-2 text-sm font-semibold text-highlight-100">{{ label }}</span>
        <input
            type="text"
            class="px-4 py-2 text-black bg-white border rounded border-highlight-20 placeholder-highlight-40 focus:outline-none focus:shadow-outline"
            :class="{ 'has-error focus:border-error': $v.local.$error }"
            :placeholder="placeholder"
            :readonly="readonly"
            :value="local"
            @input="update($event.target.value)"
            @blur="validate"
        />
    </label>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import inputField from '@/mixins/inputField'

export default {
    props: {
        placeholder: {
            type: String,
        },
    },
    mixins: [inputField],
    validations: {
        local: {
            required,
        },
    },
    watch: {
        value() {
            this.local = this.value
            this.$emit('update:validation', !this.$v.$invalid)
        },
    },
    created() {
        if (!this.$v.local.$dirty && this.local) {
            this.validate()
        }
    },
    methods: {
        validate() {
            this.$v.$touch()
            this.$emit('update:validation', !this.$v.$invalid)
        },
    },
}
</script>

<style scoped>
    input[readonly] {
        @apply bg-highlight-10 border-highlight-10;
    }

    input[readonly]:focus {
        @apply shadow-none;
    }

    input.has-error {
        @apply border-error-60;
    }

    input.has-error:focus {
        @apply shadow-error;
    }
</style>
